// 繁體中文 (zh-TW)

export const zhTW = {
  brand: {
    name: 'DoneLine',
    tagline: '專注於個人的專案管理工具',
  },
  common: {
    save: '儲存',
    cancel: '取消',
    confirm: '確認',
    delete: '刪除',
    rename: '重新命名',
    archive: '封存',
    add: '新增',
    close: '關閉',
    edit: '編輯',
    new: '新建',
    yes: '是',
    no: '否',
    back: '返回',
    next: '下一步',
    skip: '略過',
    done: '完成',
    loading: '載入中…',
    sending: '傳送中…',
    saving: '儲存中…',
    untitled: '未命名',
    today: '今天',
    tomorrow: '明天',
    yesterday: '昨天',
    none: '無',
    optional: '選填',
    requiredField: '必填',
    confirmDelete: '確認刪除？',
  },
  nav: {
    today: '今日',
    upcoming: '即將到來',
    inbox: '收件匣',
    projects: '我的專案',
    tags: '標籤',
    reports: '週報',
    settings: '設定',
    quickCapture: '快速捕捉',
    search: '搜尋',
    newProject: '新增專案',
    addSection: '新增分類',
    menu: '選單',
    openMenu: '開啟選單',
  },
  search: {
    title: '搜尋',
    placeholder: '搜尋任務、專案、標籤…',
    noResults: '沒有結果',
    tasks: '任務',
    projects: '專案',
    tags: '標籤',
  },
  today: {
    title: '今日',
    eyebrow: '今日',
    overdue: '逾期',
    today: '今日',
    completed: '已完成',
    empty: '今天沒有安排，放鬆一下 ☕',
    summary: '{active} 進行 · {done} 完成',
    reschedule: '重新安排',
    rescheduled: '已重新安排 {count} 個任務',
  },
  inbox: {
    title: '收件匣',
    eyebrow: '收件匣',
    empty: '收件匣是空的。',
    pending: '{count} 待處理',
  },
  upcoming: {
    title: '即將到來',
    eyebrow: '未來 7 天',
    todayLabel: '今天',
    tomorrowLabel: '明天',
    empty: '未來 7 天沒有任務。',
  },
  project: {
    eyebrow: '專案',
    notFound: '專案不存在',
    notFoundHint: '可能已被刪除或封存。',
    inProgress: '{count} 進行中',
    completed: '{count} 完成',
    ungrouped: '未分類',
    addSection: '新增分類',
    listView: '列表',
    ganttView: '甘特圖',
    ganttZoomIn: '放大',
    ganttZoomOut: '縮小',
    ganttWide: '寬屏',
    ganttCompact: '恢復正常寬度',
    empty: '專案還沒有任務',
    emptyHint: '使用上方輸入框開始新增。',
    sectionEmpty: '— 暫無任務 —',
    completedSection: '已完成',
    newSectionTitle: '新增分類',
    newSectionPlaceholder: '分類名稱',
    renameProjectTitle: '重新命名專案',
    renameProjectPlaceholder: '專案名稱',
    editProjectTitle: '編輯專案',
    color: '顏色',
    icon: '圖示',
    noIcon: '無圖示',
    deleteProjectTitle: '刪除專案「{name}」？',
    deleteProjectDesc: '此專案下的任務會移到收件匣。此操作無法復原。',
    archiveProject: '封存',
    actionsMenu: '專案操作',
    renameSectionTitle: '重新命名分組',
    sectionDeleteTitle: '刪除分組「{name}」？',
    sectionDeleteDesc: '此分組下的任務會移回專案根目錄，此操作無法復原。',
    sectionActionsMenu: '分組操作',
    sectionReorder: '調整分組順序',
    descriptionPlaceholder: '為這個專案寫點什麼…',
    descriptionEditHint: '支援 Markdown · ⌘↵ 儲存 · Esc 關閉',
    descriptionEmpty: '點擊新增專案說明',
  },
  upgrade: {
    title: '升級到 DoneLine Pro',
    featureLocked: '「{feature}」是 Pro 功能。',
    comingSoon: 'Pro 即將開放，到時你的帳號會自動就緒。',
    signInFirst: '登入後開通',
    benefits: {
      unlimitedProjects: '無限專案（免費版上限 3 個）',
      history: '365 天修改歷史（免費版僅 7 天）',
      gantt: '甘特圖檢視',
      importExport: '匯入 / 匯出資料',
      themes: '更多主題，包含 Paper',
    },
    feature: {
      projects: '3 個以上專案',
      gantt: '甘特圖',
      importExport: '匯入 / 匯出',
      paperTheme: 'Pro 主題',
    },
    cta: {
      stripe: '訂閱 — 月付 $2.99 / 年付 $29.99',
      apple: '透過 Apple 訂閱',
      google: '透過 Google Play 訂閱',
    },
  },
  plan: {
    title: '方案',
    description: '你的訂閱級別。',
    free: '免費',
    pro: 'Pro',
    proAi: 'Pro AI',
    upgradeButton: '升級到 Pro',
    devSwitchHint: '開發預覽：暫時切換方案以查看不同限額',
    switchToFree: '切到免費（預覽）',
    switchToPro: '切到 Pro（預覽）',
  },
  reports: {
    eyebrow: '週報',
    title: '過去 7 天回顧',
    serverGeneratedAt: '伺服器產生於 {time}',
    syncingFromServer: '從伺服器同步中…',
    computedLocally: '本地計算',
    aiSummary: 'AI 週報摘要',
    completedCount: '完成數',
    completionRate: '完成率',
    overdueCount: '逾期數',
    dailyAverage: '日均',
    dailyCompleted: '每日完成數',
    dailyCompletedAxis: '（任務數）',
    byProject: '按專案分佈',
    noCompletedThisWeek: '本週還沒完成任務。',
    serverNotReady: '伺服器還沒產生本週週報。每週一 09:00（按你的時區）batch worker 會自動產出。',
  },
  settings: {
    display: {
      title: '顯示',
      description: '選擇任務一覽行內顯示哪些資訊。',
      tags: '標籤',
      tagsHint: '在任務列顯示標籤',
      descriptionLabel: '描述',
      descriptionHint: '顯示一行描述預覽',
      subtasks: '子任務',
      subtasksHint: '顯示子任務進度與展開箭頭',
    },
    eyebrow: '設定',
    title: '偏好與外觀',
    appearance: { title: '外觀', description: '選擇最合適當下情境的主題。' },
    language: { title: '語言', description: '應用介面文字的顯示語言。' },
    desktop: {
      title: '桌面端',
      description: '原生 macOS / Windows / Linux 行為。僅在桌面應用中生效。',
      alwaysOnTopLabel: '視窗置頂',
      alwaysOnTopHint: '把視窗固定在所有應用之上，再次切換關閉。',
      globalHotkeyLabel: '全域快速捕捉快捷鍵',
      globalHotkeyHint: '系統級 ⌘⇧Space — 在任意應用喚起 DoneLine 並聚焦捕捉框。',
    },
    account: {
      title: '帳號',
      description: '登入資訊與統計總覽。',
      summary: '共 {tasks} 個任務 · {projects} 個專案',
      signOut: '登出',
      deleteAccount: '刪除帳號',
      deleteAccountConfirmTitle: '刪除帳號？',
      deleteAccountConfirmBody:
        '將永久刪除你的帳號，以及伺服器和此瀏覽器中的全部任務、專案和標籤。此操作無法復原。想保留資料請先匯出。',
      deleteAccountConfirm: '刪除',
      deleteAccountFailed: '刪除帳號失敗',
      signingOut: '登出中…',
      notSignedIn: '未登入',
      signInCta: '登入',
      guestHint: '訪客模式：資料僅存本機。登入後開啟同步與雲端備份。',
      displayNameLabel: '顯示名稱',
      displayNamePlaceholder: '你的名字',
      displayNameSaved: '已儲存',
      displayNameSaveFailed: '儲存失敗',
      avatarLabel: '頭像',
      avatarHint: '支援 JPG / PNG / WEBP / GIF，最大 2 MB。未上傳時顯示首字母。',
      avatarUpload: '上傳圖片',
      avatarChange: '更換圖片',
      avatarUploading: '上傳中…',
      avatarRemove: '移除',
      avatarSaved: '頭像已更新',
      avatarSaveFailed: '更新頭像失敗',
      avatarErrorType: '不支援的圖片格式。請使用 JPG / PNG / WEBP / GIF。',
      avatarErrorSize: '圖片過大，最大 2 MB。',
    },
    sync: {
      title: '同步',
      description: '與伺服器執行一次完整的增量同步。',
      forceSync: '立即強制同步',
      syncing: '同步中…',
      done: '同步完成',
    },
    shortcuts: { title: '快捷鍵', description: '鍵盤是最快的指標。', view: '檢視快捷鍵' },
    data: {
      title: '資料',
      description: '所有資料先存於本地，再同步至伺服器。',
      export: '匯出 JSON',
      import: '匯入 JSON',
      exportDone: '已匯出 {n} 個任務',
      importDone: '已匯入 {n} 筆新資料',
      importError: '匯入失敗：{error}',
      importPersistFailed: '匯入未能寫入本機儲存空間：資料可能超出裝置的儲存限額，請分批匯入。',
      clearAll: '清空本地資料',
      clearConfirmTitle: '清空所有本地資料？',
      clearConfirmDesc:
        '這會刪除瀏覽器中儲存的所有內容；伺服器上已同步的資料不受影響。完成後頁面會重新載入。',
      cleared: '已清空，重新載入…',
    },
    about: {
      title: '關於',
      version: '版本 {v}',
      description: '基於 GTD 理念的個人 todo 與專案管理工具。',
    },
  },
  guest: {
    banner: '訪客模式 — 資料僅保存在本機。登入後可多裝置同步。',
    bannerCta: '登入',
    emptyHint: '登入前，資料僅保存在本機。先在下方新增第一個任務吧。',
    storageWarning:
      '訪客資料僅存於此瀏覽器，可能被系統清除。請及時登入或匯出備份（匯出檔案未加密）。',
  },
  login: {
    welcomeBack: '歡迎回來',
    helperSupabase: '輸入電子郵件，給你寄一封一次性登入連結。',
    helperLocal: '本地模式：輸入電子郵件即可立刻登入（未設定 Supabase 時的 fallback）。',
    emailPlaceholder: 'you@example.com',
    sendLink: '寄送登入連結',
    sendingLink: '寄送中…',
    sentSupabase: '已寄送到 {email}，請在收件匣中點選登入連結。',
    otpPrompt: '或輸入郵件裡的驗證碼',
    otpPlaceholder: '6 位驗證碼',
    otpSubmit: '登入',
    otpFailed: '驗證碼無效或已過期',
    sentLocal: '已登入 {email}，準備中…',
    modeSupabase: 'Supabase Auth',
    modeLocal: '本地 Mock 模式（未設定後端時的回退）',
    skipGuest: '跳過，先直接使用',
    skipFailed: '無法進入訪客模式（本機儲存寫入失敗），請重試。',
    merge: {
      title: '本機已有 {count} 個任務',
      keep: '合併到我的帳號',
      irreversible: '登入後將上傳到帳號，合併後無法復原。',
      discard: '不保留本機資料，直接登入',
      discardConfirmTitle: '登入後將刪除本機 {count} 個任務',
      discardConfirmBody: '登入完成後，本機的 {count} 個任務將被永久刪除，無法復原。確定繼續？',
    },
    error: '登入失敗',
  },
  task: {
    recurringAdvanced: '重複任務已推進到 {date}',
    recurringFinished: '重複已結束，任務已完成',
    titlePlaceholder: '任務標題',
    description: '描述',
    descriptionPlaceholder: '新增描述…',
    descriptionEmpty: '尚無描述。',
    descriptionEdit: '編輯描述',
    descriptionSave: '儲存描述',
    descriptionCancel: '取消',
    save: '儲存',
    saved: '已儲存',
    discardConfirmTitle: '放棄未儲存的變更？',
    discardConfirmDesc: '你有尚未儲存的編輯，現在關閉會遺失這些改動。',
    priority: '優先級',
    date: '日期',
    project: '專案',
    section: '分類',
    parentTask: '父任務',
    tags: '標籤',
    subtasks: '子任務',
    expandSubtasks: '展開子任務',
    collapseSubtasks: '收合子任務',
    addSubtaskPlaceholder: '+ 新增子任務',
    comments: '留言',
    noComments: '暫無留言',
    commentPlaceholder: '寫一則留言…',
    sendComment: '送出',
    delete: '刪除',
    deleteConfirmTitle: '刪除這個任務？',
    deleteConfirmDesc: '它的子任務也會一併刪除。',
    saveHint: '⌘/Ctrl + Enter 儲存並關閉',
    open: '開啟',
    completed: '已完成',
    markComplete: '標記為完成',
    markIncomplete: '標記為未完成',
    moreActions: '更多操作',
  },
  priority: {
    high: '高',
    mid: '中',
    low: '低',
    none: '無',
    p1: 'P1',
    p2: 'P2',
    p3: 'P3',
    p4: 'P4',
  },
  date: {
    picker: {
      single: '單日',
      datetime: '時點',
      range: '區間',
      today: '今天',
      tomorrow: '明天',
      thisWeekend: '本週末',
      nextWeek: '下週',
      noDate: '無日期',
    },
    overdue: '逾期',
    notScheduled: '未設日期',
  },
  recurrence: {
    title: '重複',
    none: '不重複',
    custom: '自訂…',
    applyCustom: '套用自訂規則',
    end: '結束重複',
    preset: {
      daily: '每天',
      weekdays: '工作日',
      weekly: '每週',
      biweekly: '每 2 週',
      monthly: '每月',
      yearly: '每年',
    },
    summary: {
      daily: '每天',
      everyNDays: '每 {n} 天',
      weekly: '每週',
      everyNWeeks: '每 {n} 週',
      weeklyOn: '每週{days}',
      everyNWeeksOn: '每 {n} 週 · {days}',
      monthly: '每月',
      everyNMonths: '每 {n} 個月',
      yearly: '每年',
      everyNYears: '每 {n} 年',
    },
    weekday: { sun: '日', mon: '一', tue: '二', wed: '三', thu: '四', fri: '五', sat: '六' },
    freq: { daily: '天', weekly: '週', monthly: '月', yearly: '年' },
    every: '每',
  },
  aiUsage: {
    title: 'AI 用量',
    planFree: '免費檔',
    planPro: 'Pro 檔',
    planProAi: 'Pro AI 檔',
    usedOf: '本月 {used} / {limit} 次',
    remaining: '剩餘 {count} 次',
    resetsMonthly: '每月 1 日（UTC）重置',
    history: '最近使用',
    historyEmpty: '還沒有使用記錄',
    endpointParse: 'AI 解析',
    endpointBreakdown: 'AI 拆解',
    signInFirst: '登入後可查看 AI 用量',
    loadFailed: '載入失敗',
    retry: '重試',
  },
  parseTask: {
    mode: 'AI',
    quickMode: '快速',
    title: 'AI 任務解析',
    placeholder: '用一句話描述任務…',
    titlePlaceholder: '任務標題',
    hint: 'AI 自動填好日期、優先級、專案與標籤',
    parse: '解析',
    confirm: '新增任務',
    confirmMany: '新增 {count} 個任務',
    back: '返回',
    voice: '語音輸入',
    voiceDenied: '麥克風權限被拒絕',
    voiceUnavailable: '目前的瀏覽器不支援語音輸入',
    errors: {
      rateLimited: '請求過於頻繁，請稍後再試',
      monthlyLimit: '本月 AI 次數已用完，升級可獲得更多',
      unauthorized: '請先登入後再使用 AI',
      unavailable: 'AI 暫時無法使用',
      failed: '無法解析任務，請換個說法',
    },
  },
  quickCapture: {
    placeholder: '新增任務…（Enter 儲存）',
    hint: '試試：「買菜 tomorrow @生活 #快速 p2」',
    newTag: '#{name}（新建）',
    dismissMatch: '將「{label}」保留為文字',
    createTag: '建立標籤「{name}」',
    syntaxCheatsheet: 'today / tomorrow / next mon · @專案[/分區] · #標籤 · p1-p4',
    add: '新增',
    open: '開啟快速捕捉',
    addTask: '新增任務',
  },
  tag: {
    eyebrow: '標籤',
    editTagTitle: '編輯標籤',
    renameTagPlaceholder: '標籤名稱',
    newTagPlaceholder: '新標籤…',
    deleteTagTitle: '刪除標籤「{name}」？',
    deleteTagDesc: '將從 {count} 個任務移除該標籤，此操作無法復原。',
    actionsMenu: '標籤操作',
    nameTaken: '已有同名標籤',
    empty: '沒有帶此標籤的任務',
  },
  quickbar: {
    signInRequired: '請先登入',
    signInHint: '登入後才能從狀態列新增任務。',
    signInOpenMain: '請開啟 DoneLine 主視窗完成登入',
  },
  sync: {
    idle: '已同步',
    syncing: '同步中',
    offline: '離線',
    error: '同步失敗',
    disabled: '本地模式',
    pending: '{count} 待上傳',
    syncingPending: '同步中 · {count} 待上傳',
    offlinePending: '離線 · {count} 待上傳',
    authError: '認證失敗 — 請重新登入',
    rejectedBatch: 'Data validation failed — some changes were dropped',
    retry: '點擊重試',
  },
  commandPalette: {
    placeholder: '搜尋任務、跳轉檢視、執行命令…',
    empty: '沒有符合項。',
    tasks: '任務',
    projects: '專案',
    navigation: '導覽',
    actions: '操作',
  },
  bulk: {
    toolbar: '批次操作',
    selected: '已選 {count} 項',
    clear: '取消選取',
    deleteTitle: '刪除選取的 {count} 個任務？',
    deleteDesc: '其子任務也會一併刪除。此動作無法復原。',
    mixedProjects: '多個專案',
  },
  shortcuts: {
    title: '快捷鍵',
    quickAdd: '快速捕捉',
    search: '搜尋',
    help: '顯示此面板',
    gotoToday: '跳至今日',
    gotoInbox: '跳至收件匣',
    gotoUpcoming: '跳至即將到來',
    drawer: {
      title: '任務詳情中',
      saveClose: '儲存並關閉',
      delete: '刪除任務',
      priorityKeys: '設定優先級（1=高 … 4=無）',
    },
  },
  welcome: {
    title: '歡迎使用 {brand}',
    subtitle: '30 秒帶你上手。',
    step1: {
      title: '一秒捕捉任何想法',
      body: '任意頁面按 Q 鍵開啟快速捕捉。輸入任務名按 Enter，直接進入收件匣。',
    },
    step2: {
      title: '有空再整理',
      body: '把任務拖至專案和分類中。日期、優先級、標籤都可以稍後再補。',
    },
    step3: {
      title: '規劃每一天',
      body: '今日視圖自動匯總今天到期、以及覆蓋今天的日期區間內的所有任務。',
    },
    step4: { title: '準備就緒', body: '我們準備了幾個引導任務協助你熟悉操作，完成或刪除隨你。' },
    getStarted: '開始使用',
  },
  onboarding: {
    project: { welcome: '歡迎', learn: '了解' },
    tasks: {
      welcome: '👋 歡迎使用 {brand}！',
      welcomeDesc: '點選左側的核取方塊把這條標記為完成 —— 這就是完成任務的方式。',
      quickAdd: '⚡ 試試快速捕捉：按 Q 鍵，或左上角的快速捕捉按鈕',
      quickAddDesc:
        '輸入任務名按 Enter 即可。可以用 @專案名 歸至專案、#標籤名 加標籤、p1-p4 設優先級。',
      organize: '📁 用專案把相關任務組織起來',
      organizeDesc: '點左側欄「+ 新增專案」建立。把任務拖入整理。',
      schedule: '🗓 設定日期來安排時間',
      scheduleDesc: '設了今天的任務會自動出現在「今日」視圖。試試開啟這條任務並設個截止日期。',
      priority: '🔥 使用優先級（P1 高 … P4 無）',
      priorityDesc: '在任務詳情中按 1 / 2 / 3 / 4 快速切換優先級。',
      drag: '✋ 拖動重新排序',
      dragDesc: '把游標移至任務上，左側會出現拖動把手，按住可拖至新位置。',
      gantt: '📊 用甘特圖看時間軸',
      ganttDesc: '開啟任一專案，切換至「甘特圖」標籤，看任務在時間軸上的分佈。',
      reports: '📈 用週報回顧',
      reportsDesc: '每週看你完成了什麼、哪些被推遲了。',
      finishMe: '✅ 把這個清單完成 —— 你已準備好了！',
    },
  },
  errors: {
    networkError: '網路錯誤',
    unknownError: '未知錯誤',
    notFound: '未找到',
    pageNotFound: '頁面未找到',
    pageNotFoundDesc: '此網址不存在，或已被移動。',
    backHome: '回到今日',
    somethingWrong: '發生問題',
    tryAgain: '重試',
    goHome: '回到首頁',
  },
  theme: {
    light: '淺色',
    dark: '深色',
    paper: '紙張',
    rose: '玫瑰',
    lavender: '薰衣草',
    peach: '蜜桃',
    mauve: '暗玫',
    slate: '石板',
    forest: '森林',
    midnight: '午夜',
    shiba: '柴犬',
    cat: '貓咪',
    ocean: '海洋',
    sky: '天空',
    mint: '薄荷',
    matcha: '抹茶',
    amber: '琥珀',
    mocha: '摩卡',
    crimson: '緋紅',
    nord: '北歐',
    dracula: '德古拉',
    graphite: '石墨',
    system: '系統',
    pickerTitle: '主題',
  },
} as const;
